const careerPage = {
  "career.watch.video": "Watch video",
  "career.get-ready": "Get Ready...",
};

const leagueChange = {
  "career.promotion.title": "Congratulations!",
  "career.promotion.subtitle": "Welcome to",

  "career.relegation.title": "Relegated",
  "career.relegation.subtitle": "You're back in",
};

const careerStatus = {
  "career.status.no.briefing": "Reach the targets to progress to the next division",
  "career.status.progress.base": "{{ divisions }} Divisions left to {{ league }} League",
  "career.status.progress.last": "Complete challenge to reach {{ league }} League",
};

const careerTargets = {
  "career.targets.title": "Your targets",
};

export const career = {
  ...careerPage,
  ...leagueChange,
  ...careerStatus,
  ...careerTargets,
};
